export default "__VITE_ASSET__DG76pVY4__"